import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useConfiguration } from '../../../../context/configurationContext';
import css from './BaseListingPage.module.css';
import TopbarContainer from '../../../TopbarContainer/TopbarContainer';
import { createResourceLocatorString } from '../../../../util/routes';
import { LISTING_PAGE_PARAM_TYPE_NEW } from '../../../../util/urlHelpers';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import classNames from 'classnames';
import sell from '../../../../assets/sell.png';
import book from '../../../../assets/book.png';
import list from '../../../../assets/list.png';
import Icons from '../../../../components/Icons/Icons';
import { FormattedMessage } from 'react-intl';

const draftId = '00000000-0000-0000-0000-000000000000';

const BaseListingPage = props => {
  const config = useConfiguration();
  const listingTypes = config?.listing?.listingTypes || [];
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const [selectedServices, setSelectedServices] = useState(null);
  const handleCardSelect = type => {
    setSelectedServices(type);
  };

  const handleContinue = () => {
    if (selectedServices !== null) {
      const searchParams = {
        id: draftId,
        slug: 'draft',
        type: LISTING_PAGE_PARAM_TYPE_NEW,
        tab: 'details',
      };
      // Construct URL and navigate to EditListingPage
      const path = createResourceLocatorString(
        'EditListingPage',
        routeConfiguration,
        searchParams,
        { listingType: selectedServices }
      );
      history.push(path);
    }
  };

  return (
    <>
      <TopbarContainer
        mobileRootClassName={css.mobileTopbar}
        desktopClassName={css.desktopTopbar}
        mobileClassName={css.mobileTopbar}
      />
      <div className={css.listingContainer}>
        <div className={css.listingHead}>
          <h2>
            <FormattedMessage id="BaseListingPage.createNewListing" />
          </h2>
          <div className={css.listingSteps}>
            {listingTypes.map((step, index) => {
              const stepIndex = listingTypes.findIndex(type => type.label === step.label);
              const isCompleted =
                stepIndex !== -1 && listingTypes[stepIndex].listingType === selectedServices;
              const isInProgress = stepIndex === index && selectedServices === null;

              return (
                <div
                  key={step.id}
                  className={classNames(css.step, {
                    [css.completed]: isCompleted,
                    [css.inprogress]: isInProgress,
                  })}
                >
                  <span className={css.counter}></span>
                  <p>
                    <FormattedMessage id={`BaseListingPage.${step.label}`} />
                  </p>
                </div>
              );
            })}
          </div>
        </div>
        <div className={css.listingContent}>
          {listingTypes.map((type, index) => (
            <div
              key={index}
              className={`${css.card} ${selectedServices === type.listingType ? css.selected : ''}`}
              onClick={() => handleCardSelect(type.listingType)}
            >
              <span className={css.check}>
                <Icons
                  name={selectedServices === type.listingType ? 'radioCheck' : 'radioUncheck'}
                />
              </span>
              <div className={css.cardImg}>
                <img
                  src={type.label === 'Products' ? sell : type.label === 'Services' ? book : list}
                  alt=""
                />
              </div>
              <div className={css.cardInfo}>
                <h3 className={css.cardTitle}>{type.label}</h3>
              </div>
            </div>
          ))}
        </div>
        <button
          className={css.continueButton}
          disabled={selectedServices === null}
          onClick={handleContinue}
        >
          <FormattedMessage id="BaseListingPage.Continue" />
        </button>
      </div>
    </>
  );
};

BaseListingPage.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default BaseListingPage;
